import { useMemo } from "react";
import { Shipment } from "../../services/prePlanningService.types";

export interface InboundAppointmentSummary {
  totalPalletsPlanned: number;
  totalPalletsUnplanned: number;
  totalPiecesPlanned: number;
  totalPiecesUnplanned: number;
  totalWeightPlanned: number;
  totalWeightUnplanned: number;
  filteredPlannedShipments: Shipment[];
  filteredUnplannedShipments: Shipment[];
}

export const useInboundAppointmentSummary = (
  shipments: Shipment[]
): InboundAppointmentSummary =>
  useMemo(() => {
    const filteredPlannedShipments = shipments.filter(
      (shipment) => shipment.isPlanned === true
    );
    const filteredUnplannedShipments = shipments.filter(
      (shipment) => shipment.isPlanned === false
    );

    const totalPalletsPlanned = filteredPlannedShipments.reduce(
      (acc, shipment) => acc + shipment.pallets,
      0
    );
    const totalPalletsUnplanned = filteredUnplannedShipments.reduce(
      (acc, shipment) => acc + shipment.pallets,
      0
    );

    const totalPiecesPlanned = filteredPlannedShipments.reduce(
      (acc, shipment) => acc + shipment.pieces,
      0
    );
    const totalPiecesUnplanned = filteredUnplannedShipments.reduce(
      (acc, shipment) => acc + shipment.pieces,
      0
    );

    const totalWeightPlanned = filteredPlannedShipments.reduce(
      (acc, shipment) => acc + shipment.weight,
      0
    );
    const totalWeightUnplanned = filteredUnplannedShipments.reduce(
      (acc, shipment) => acc + shipment.weight,
      0
    );

    return {
      totalPalletsPlanned,
      totalPalletsUnplanned,
      totalPiecesPlanned,
      totalPiecesUnplanned,
      totalWeightPlanned,
      totalWeightUnplanned,
      filteredPlannedShipments,
      filteredUnplannedShipments,
    };
  }, [shipments]);
